// Types
interface Transcription {
  speaker_id: string;
  duration: string;
  text: string;
  summary?: string;
  isSummaryGenerated?: boolean;
}

interface RecordingState {
  isRecognizing: boolean;
  transcriptions: Transcription[];
}

const initialState: RecordingState = {
  isRecognizing: false,
  transcriptions: [],
};

// Action Types
const START_RECORDING = "START_RECORDING";
const STOP_RECORDING = "STOP_RECORDING";
const ADD_TRANSCRIPTION = "ADD_TRANSCRIPTION";
const UPDATE_SUMMARY = "UPDATE_SUMMARY";
//const UPDATE_AGENDA_SUMMARY = "UPDATE_AGENDA_SUMMARY";
const UPDATE_TRANSCRIPTIONS = "UPDATE_TRANSCRIPTIONS";

const recordingReducer = (state: any = initialState, action: any) => {
  switch (action.type) {
    case START_RECORDING:
      console.log("action.payload:st:", action.payload);
      return {
        ...state,
        isRecognizing: action.payload,
      };
    case STOP_RECORDING:
      console.log("action.payload::stop", action.payload);

      return {
        ...state,
        isRecognizing: action.payload,
        transcriptions: [...state.transcriptions, action.payload],
      };
    case ADD_TRANSCRIPTION:
      return {
        ...state,
        transcriptions: [...state.transcriptions, action.payload],
      };
    case UPDATE_TRANSCRIPTIONS:
      return {
        ...state,
        transcriptions: action.payload,
      };
    case UPDATE_SUMMARY:
      const { index, summary } = action.payload;
      const updatedTranscriptions = [...state.transcriptions];
      if (updatedTranscriptions[index]) {
        updatedTranscriptions[index].summary = summary;
        updatedTranscriptions[index].isSummaryGenerated = true;
      }
      return { ...state, transcriptions: updatedTranscriptions };
    //case UPDATE_AGENDA_SUMMARY:

    default:
      return state;
  }
};

export default recordingReducer;
